/* eslint-disable no-undef */
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Integration } from 'Pages/integration/integration';
import { PageNotFound } from 'Pages/pageNotFound/pageNotFound';
import IntegrationDetail from './integrationDetail';

const IntegrationRouter = observer(props => {

  return (
    <Switch>
      <Route path="/integrations" exact component={Integration} />
      <Route
        path="/integrations/:crmType/:menu/:mappingType?"
        component={IntegrationDetail}
      />
      <Route path="/*" component={PageNotFound} />
    </Switch>
  );
});

export default withRouter(IntegrationRouter);
